// extracted by mini-css-extract-plugin
export default {"container":"BUSINESS_EXAMPLES_container__u+aEE","card":"BUSINESS_EXAMPLES_card__v4J9N"};